<template lang="pug">
  #challenge-center-admin-challenge-settings
   ProgramSettingsFormWrapper(
    :form-data="formData"
    :disable-save.sync="disableSave"
    :keys-to-reset="keysToReset"
    title="Challenge Settings"
  )
    template
      .columns.is-multiline
        .column
          WtSwitchQuestionInput(
            label="Allow Members to Create (Non-Featured) Challenges"
            :tooltip-text="memberChallengeCreationTooltip"
            v-model="memberChallengeCreation"
            @input="disableSave = false"
            name="member created challenge"
          )
          WtSwitchQuestionInput(
            label="Challenge Invite Notification Emails"
            :tooltip-text="challengeInviteNotificationsTooltip"
            v-model="challengeInviteEmails"
            @input="disableSave = false"
            name="challenge invite emails"
          )
          WtSwitchQuestionInput(
            label="Milestone Notification Emails"
            :tooltip-text="milestoneNotificationsTooltip"
            v-model="milestoneEmails"
            @input="disableSave = false"
            name="milestone emails"
          )

</template>

<script>
import { mapActions, mapGetters } from "vuex";
import WtSwitchQuestionInput from "@@/WtSwitchQuestionInput/WtSwitchQuestionInput";
import programSettingsFormMixin from "@/mixins/programSettingsFormMixin";
import ProgramSettingsFormWrapper from "@@/ProgramSettingsAdmin/ProgramSettingsFormWrapper";

export default {
  name: "ChallengeCenterAdminChallengeSettings",

  components: {
    WtSwitchQuestionInput,
    ProgramSettingsFormWrapper
  },

  mixins: [programSettingsFormMixin],

  data() {
    return {
      memberChallengeCreationTooltip: `
      If turned on, your participants will be able to create challenges and challenge each other, both in the web and mobile apps. This can be a great way to drive participation when no featured challenge is running.
      `,

      challengeInviteNotificationsTooltip: `
      Allow Be Well to send an email to members when
      they are invited to join a challenge.
      `,
      milestoneNotificationsTooltip: `
      Allow Be Well to email members when they pass a
      milestone in a featured challenge.
      `
    };
  },

  computed: {
    ...mapGetters("program", [
      "coreProgramMeta",
      "programSettingsCopy",
      "programLoaded"
    ]),

    formData() {
      return {
        challengeInviteEmails: this.challengeInviteEmails,
        milestoneEmails: this.milestoneEmails,
        memberChallengeCreation: this.memberChallengeCreation
      };
    },

    keysToReset() {
      return [
        "milestoneEmails",
        "challengeInviteEmails",
        "memberChallengeCreation"
      ];
    },

    memberChallengeCreation: {
      set(memberChallengeCreation) {
        this.updateProgramSettingsCopy({
          key: "memberChallengeCreation",
          value: memberChallengeCreation
        });
      },
      get() {
        return Number(this.programSettingsCopy.memberChallengeCreation);
      }
    },

    milestoneEmails: {
      set(milestoneEmails) {
        this.updateProgramSettingsCopy({
          key: "milestoneEmails",
          value: milestoneEmails
        });
      },
      get() {
        return Number(this.programSettingsCopy.milestoneEmails);
      }
    },

    challengeInviteEmails: {
      set(challengeInviteEmails) {
        this.updateProgramSettingsCopy({
          key: "challengeInviteEmails",
          value: challengeInviteEmails
        });
      },
      get() {
        return Number(this.programSettingsCopy.challengeInviteEmails);
      }
    }
  },

  methods: {
    ...mapActions("program", ["updateProgramSettingsCopy"])
  }
};
</script>

<style lang="sass" scoped></style>
